/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Languagetitle2Inputs */

const zh_systemsettings_languagetitle2 = /** @type {(inputs: Systemsettings_Languagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const en_systemsettings_languagetitle2 = /** @type {(inputs: Systemsettings_Languagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const es_systemsettings_languagetitle2 = /** @type {(inputs: Systemsettings_Languagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Systemsettings_Languagetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_languagetitle2 = /** @type {((inputs?: Systemsettings_Languagetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Languagetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_languagetitle2(inputs)
	if (locale === "en") return en_systemsettings_languagetitle2(inputs)
	return es_systemsettings_languagetitle2(inputs)
});
export { systemsettings_languagetitle2 as "systemSettings_languageTitle" }